@if (this.currentCompanyStore.loaded()) {
  <dw-grid-list-page
    [title]="'Doc::Menu:SupplierPurchaseOrders' | abpLocalization"
    [activeView]="agGrid.activeView"
    (createAction)="createEntity()"
    [createActionLabel]="'::Add'"
    (deleteAction)="deleteEntities()"
    [enableDeleteBtn]="selectedEntities().length > 0"
    (exportAction)="agGrid.export()"
    [enableDuplicateBtn]="selectedEntities().length == 1"
    [showDuplicateBtn]="true"
    (duplicateAction)="duplicateSupplierQuote()"
    [hasQuickSearch]="true"
  >
    <dw-grid-ag-grid
      [columnDefs]="columns"
      [datasource]="datasource"
      (rowClicked)="rowClicked($event)"
      [(selectedRows)]="selectedEntities"
      (selectedRowsClicked)="selectedRowsClicked($event)"
      #agGrid
      [context]="GoliathDocumentEntityNames.SupplierPurchaseOrder.shortName"
    >
    </dw-grid-ag-grid>
  </dw-grid-list-page>
}
